import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style, updateElementStyles } from '../../utils/style.utils';
import {
    tabsTabStylesActiveSAG,
    tabsTabStylesActiveSHS,
    tabsTabStylesDisabledSAG,
    tabsTabStylesDisabledSHS,
    tabsTabStylesSAG,
    tabsTabStylesSHS
} from './tabs-tab.styles';

@Directive({
    selector: '[sag-ui-tabs-tab]'
})
export class TabsTabDirective implements OnInit {
    @Input() disabled = false;

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('active')
    set setActive(active: boolean) {
        this.active = active;
        this.applyStyles();
    }

    private active = false;

    constructor(
        @Inject(THEME_TOKEN) private readonly theme: Theme,
        private readonly elementRef: ElementRef<HTMLInputElement>
    ) {}

    private applyStyles() {
        if (this.disabled) {
            style(
                this.elementRef,
                componentStylesByTheme(this.theme, tabsTabStylesDisabledSAG, tabsTabStylesDisabledSHS)()
            );
            return;
        }

        const activeStyles = componentStylesByTheme(this.theme, tabsTabStylesActiveSAG, tabsTabStylesActiveSHS);

        const defaultStyles = componentStylesByTheme(this.theme, tabsTabStylesSAG, tabsTabStylesSHS);

        updateElementStyles(this.elementRef, this.active ? activeStyles() : defaultStyles());
    }

    ngOnInit(): void {
        this.applyStyles();
    }
}
